import { combineReducers } from 'redux';

import applicationDataReducer from './applicationData';
import applicationStateReducer from './applicationState';
import dogReducer from './dogs';
import messagingReducer from './messaging';
import profileReducer from './profile';
import searchReducer from './search';
import { user as userReducer } from './user';

const rootReducer = combineReducers({
  appdata: applicationDataReducer,
  appstate: applicationStateReducer,
  dogs: dogReducer,
  profile: profileReducer,
  user: userReducer,
  search: searchReducer,
  messaging: messagingReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js